// 正则测试
<template>
	<el-container>
		<div class="edit-text">
			<editor v-model="rawData" @init="editorInit" :options="{wrap: true}" lang="text" :theme="editorTheme"
				width="100%" height="100%">
			</editor>
		</div>
		<div class="regular-container" style="margin: 15px 0px;">
			<el-input placeholder="请输入正则表达式" v-model="regularText"  size="mini" clearable></el-input>
			<el-checkbox v-model="globalChecked">全局搜索</el-checkbox>
			<el-checkbox v-model="caseChecked">忽略大小写</el-checkbox>
			<el-button type="primary" plain size="mini" @click="aaa">测试匹配</el-button>
		</div>
		<div class="edit-text">
			<editor v-model="findData" @init="editorInit" :options="{wrap: true, readOnly:false}" lang="text" :theme="editorTheme"
				width="100%" height="100%">
			</editor>
		</div>
		<div class="regular-container" style="margin: 15px 0px;">
			<el-input placeholder="请输入替换内容" v-model="input"  size="mini" clearable></el-input>
			<el-button type="primary" plain size="mini" @click="bbb">替换</el-button>
		</div>
		<div class="edit-text">
			<editor v-model="resultText" @init="editorInit" :options="{wrap: true, readOnly:false}" lang="text" :theme="editorTheme"
				width="100%" height="100%">
			</editor>
		</div>
	</el-container>
</template>

<script>
	export default {
		name: "g-regular",
		data() {
			return {
				rawData: '',
				findData: '',
				regularText: ``,
				
				globalChecked:true,
				caseChecked:false,
				
				input:'',
				resultText:'',
			};
		},
		components: {
			editor: require('vue2-ace-editor'),
		},
		methods: {
			aaa(){
				let extend = ''
					
				if(this.globalChecked){
					extend +='g'
				}
				if(this.caseChecked){
					extend +='i'
				}
	
				try{
					let reg = new RegExp(this.regularText, extend); //正则表达式
					let nowData = this.rawData.match(reg);
					
					let len = nowData?(this.globalChecked?nowData.length:(nowData.length-1)):0;
					this.findData = '共找到 '+len+' 处匹配：\n'
					
					if(nowData){
						if(this.globalChecked){
							for(let o of nowData){
								this.findData += o+'\n'
							}
						}else{
							this.findData += nowData[0]
						}
					}
				}catch(e){
					this.findData = '正则错误：\n'
					this.findData += e+''
				}
				
			},
			bbb(){
				let extend = ''
					
				if(this.globalChecked){
					extend +='g'
				}
				if(this.caseChecked){
					extend +='i'
				}
				
				try{
					let reg = new RegExp(this.regularText,extend); //正则表达式
					let nowData = this.rawData.replace(reg, this.input)
					
					let matchData = this.rawData.match(reg);
					let len = matchData?(this.globalChecked?matchData.length:(matchData.length-1)):0;
					this.resultText = '共替换了 '+len+' 处：\n'
					
					this.resultText += nowData
				}catch(e){
					this.resultText = '正则错误：\n'
					this.resultText += e+''
				}
			}
		},
		created() {
			if(process.env.NODE_ENV=='development'){
				this.rawData = '<p><img style="width: 140px; height: 105px;" alt="" srC="/ckfinder/userfiles/images/qi_cym.jpg" data-cke-saved-src="/ckfinder/userfiles/images/qi_cym.jpg"></p><p><br></p>'
				this.regularText = `src="([^"]*)"`
			}
				
		},
		mounted() {

		},
	};
</script>

<style lang="scss" scoped>
	.el-container /deep/ {
		flex-flow: column;
		display: flex;

		.edit-text {
			flex: 1;
			display: flex;
			border: 1px solid #DCDFE6;
			border-radius: 3px;
			overflow: hidden;
		}
		
		.regular-container{
			display: flex;
			align-items: center; 
			
			.el-checkbox{
				margin-right: 0px;
			}
			.el-checkbox+.el-button, .el-input+.el-checkbox, .el-checkbox+.el-checkbox, .el-input+.el-button {
				margin-left: 15px;
			}
		}
	}
</style>
